import { Component } from '@angular/core';

@Component({
  selector: 'twaice-fe-side-nav-separator',
  templateUrl: './side-nav-separator.component.html',
  styleUrls: ['./side-nav-separator.component.scss'],
  standalone: false,
})
export class SideNavSeparatorComponent {}
